<template>
  <div>
    <FadeAlertDanger ref="alert" :msg="msgErro" />
    <b-modal
      id="modal-prevent-closing"
      ref="companyModalChossen"
      :title="$t('sidebar.empresas')"
      size="xl"
    >
      <b-table
        id="my-table"
        class="table-nowrap"
        :busy.sync="isBusy"
        :items="getAllCompanys"
        :fields="fields"
        :filter="tableFilters"
        :filter-debounce="500"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
        responsive
      >
        <template v-slot:cell(actions)="data">
          <b-button
            v-if="userRms"
            size="sm"
            @click="loginCompany(data.item.numeroDocumento)"
            :disabled="data.item.status != 1"
            >Acessar</b-button
          >
        </template>
        <template slot="thead-top" slot-scope="{ fields }">
          <b-tr>
            <b-th v-for="field in fields" :key="field.filterKey">
              <div v-if="tableFilters[field.filterKey] != null">
                <b-form-select
                  v-if="field.filterKey == 'status'"
                  :options="statusOpt"
                  v-model="tableFilters[field.filterKey]"
                >
                </b-form-select>
                <b-form-input
                  v-else
                  v-model="tableFilters[field.filterKey]"
                  :placeholder="'Buscar por ' + field.label"
                />
              </div>
            </b-th>
          </b-tr>
        </template>
      </b-table>
      <b-row>
        <table-pagination-props
          :currentPage.sync="tableCurrentPage"
          :pageOptions.sync="tablePageOptions"
          :perPage.sync="tablePerPage"
          :rowCount.sync="tableRowCount"
        >
        </table-pagination-props>
      </b-row>
      <template #modal-footer="{ ok, cancel }">
        <div class="right">
          <b-button class="ml-2" variant="green" @click="ok()">
            {{ $t("geral.confirm") }}
          </b-button>
          <b-button class="ml-2" variant="danger" @click="cancel()">
            {{ $t("geral.cancel") }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "CompanyModal",
  props: {
    module: String,
  },
  components: {
    tablePaginationProps: () =>
      import("@/components_rms/base/TablePaginationProps.vue"),
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
  },
  data() {
    return {
      companys: [],
      isBusy: false,
      statusOpt: [
        { value: 0, text: "Todos" },
        { value: 1, text: "Ativo" },
        { value: 2, text: "Inativo" },
        { value: 3, text: "Bloqueado" },
      ],
      fields: [
        {
          key: "actions",
          sortable: false,
          label: "",
        },
        {
          key: "status",
          filterKey: "status",
          label: "Status",
          formatter: (value, key, item) => {
            if (value == 1) {
              return "Ativo";
            } else if (value == 2) {
              return "Inativo";
            } else if (value == 3) {
              return "Bloqueado";
            }
          },
        },
        {
          key: "numeroDocumento",
          filterKey: "numeroDocumento",
          label: "Numero Documento",
        },
        {
          key: "razaoSocial",
          filterKey: "razaoSocial",
          label: "Razao Social",
        },
        {
          key: "nomeFantasia",
          filterKey: "nomeFantasia",
          label: "Nome Fantasia",
        },
        {
          key: "planName",
          filterKey: "planName",
          label: "Plano",
        },
      ],
      tableFilters: {
        numeroDocumento: "",
        razaoSocial: "",
        nomeFantasia: "",
        razaoSocial: "",
        telefoneComercial: "",
        celular: "",
        email: "",
        planName: "",
        status: 1,
      },
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
      userRms: false,
      msgErro: "",
    };
  },
  methods: {
    async isRmsUser() {
      this.$apiScheduler.get("/user/isRms").then((response) => {
        this.userRms = response.data;
      });
    },
    async loginCompany(companyDocument) {
      let login = {
        userName: this.$store.getters.getUserName,
        password: "",
        companyDocument: companyDocument,
      };
      try {
        await this.$store
          .dispatch("loginRms", login)
          .then(() => {
            this.$router.push("/");
          })
          .catch((error) => {
            console.log(error);
            if (error.response) {
              this.msgErro = error.response.data.message;
            } else {
              this.msgErro = error.toString();
            }
            this.$refs.alert.show();
          });
      } catch (e) {
        console.log(e);
        this.msgErro = "Erro inexperado";
        this.$refs.alert.show();
      }
    },
    openModal() {
      this.isRmsUser();
      this.$refs.companyModalChossen.show();
    },
    getAllCompanys(ctx, callback) {
      this.isBusy = true;
      let apiParam = {
        currentPage: ctx.currentPage,
        perPage: ctx.perPage,
        documentNumber: ctx.filter.numeroDocumento,
        corporateName: ctx.filter.razaoSocial,
        fantasyName: ctx.filter.nomeFantasia,
        commercialPhone: ctx.filter.telefoneComercial,
        cellPhone: ctx.filter.celular,
        email: ctx.filter.email,
        planName: ctx.filter.planName,
        status: ctx.filter.status,
      };
      this.$apiScheduler
        .post("/empresa/all/modal", apiParam)
        .then((response) => {
          const items = response.data.items;
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          callback(items);
        })
        .catch((error) => {
          this.alert.error =
            error.response.status + " - " + error.response.statusText;
          this.$refs.danger.show();
        });
    },
  },
};
</script>

<style scoped>
.right {
  text-align: right;
  width: 100%;
}
</style>
